import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NotificationsService } from '../services/notifications/notifications.service';
import { NotificationsStore } from '../services/notifications/notifications.store';
import { Router } from '@angular/router';
import { NotificationModel } from 'src/app/models/notificationModel';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/user-services/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  @Output() showNotificationsMenuEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() menuNotificationsStatus: any;
  @Input() isLogged: boolean;

  getDropdownNotificationsSubscription: Subscription;
  markAsReadEventSubscription: Subscription;

  pageNumber = 1;
  pageSize = 5;

  isGuest: boolean;

  constructor(
    private service: NotificationsService,
    public store: NotificationsStore,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isGuest = this.authService.user?.profile?.role === 'CedLabGuest';

    if (!this.isGuest) {
      this.getDropdownRecords();
    }
  }

  getDropdownRecords() {
    this.getDropdownNotificationsSubscription = this.service.getDropdownNotifications().subscribe(
      () => { },
      err => console.error(err)
    );
  }

  showNotificationsMenu() {
    this.showNotificationsMenuEvent.emit(null);
  }

  countUnreadNotifications() {
    const count = this.store.totalUnreadNotifications;
    return count;
  }

  goToSelectedNotification(notification: NotificationModel) {
        const destinationUrl = 'menu/viewall/notifications?id=' + notification.id;
        this.router.navigateByUrl(destinationUrl);
  }

  goToNotifications() {
    const destinationUrl = 'menu/viewall/notifications';
    this.router.navigateByUrl(destinationUrl);
  }

  markAsReadEvent(notification: NotificationModel) {
      return this.service.patch(notification, this.pageNumber, this.pageSize, true);
  }

  ngOnDestroy() {
    this.getDropdownNotificationsSubscription?.unsubscribe();
    this.markAsReadEventSubscription?.unsubscribe();
  }
}
